// extracted by mini-css-extract-plugin
export default {"container":"oA-z","vocBtn":"pA-z","disabled":"qA-z"};